import React from "react";
import clsx from "clsx";
import {
  BackButton,
  MobileFloatingButton,
  MobilePopoverCard,
  frequentFlyerRegex as rewardsRegex,
} from "halifax";
import { ITravelerStepErrors } from "redmond";

import "./styles.scss";
import { HertzLoyaltyForm } from "../HertzRewardsForm";
import { FlightNumberForm } from "../FlightNumberForm";
import { CONTINUE } from "./constants";

export enum HertzLoyaltyStep {
  Main,
  HertzLoyaltyForm,
}

export interface IHertzLoyaltyWorkflowProps {
  progressStep: HertzLoyaltyStep;
  setProgressStep: (progressStep: HertzLoyaltyStep) => void;
  onGoBack?: () => void;
  onContinueClick?: () => void;
  mobileHeaderElement?: JSX.Element;
  isMobile?: boolean;
  showErrors?: ITravelerStepErrors;
  setShowErrors?: (showErrors: ITravelerStepErrors) => void;
  hertzLoyaltyRewardsNumber?: string;
  isTravelApp?: boolean;
  showHertzLoyalty?: boolean;
  showFlightNumberForm?: boolean;
  isFlightInfoValid?: boolean;
}

// Mobile checkout-extras pane: renders Hertz loyalty and/or flight-number form per the flags below (flight-only for non-Hertz — CT1265T-170).
export const HertzLoyaltyWorkflow = ({
  progressStep,
  setProgressStep,
  onGoBack,
  onContinueClick,
  mobileHeaderElement,
  showErrors,
  setShowErrors,
  hertzLoyaltyRewardsNumber,
  isTravelApp,
  showHertzLoyalty = true,
  showFlightNumberForm = false,
  isFlightInfoValid = true,
}: IHertzLoyaltyWorkflowProps) => {
  const [openHertzLoyaltyFormModal, setHertzLoyaltyFormModal] =
    React.useState<boolean>(false);

  const setProgress = (step: HertzLoyaltyStep) => {
    setProgressStep(step);
  };

  React.useEffect(() => {
    switch (progressStep) {
      case HertzLoyaltyStep.Main:
        setHertzLoyaltyFormModal(false);
        break;
      case HertzLoyaltyStep.HertzLoyaltyForm:
        setHertzLoyaltyFormModal(true);
        break;
      default:
        break;
    }
  }, [progressStep]);

  const hasValidLoyaltyNumber = hertzLoyaltyRewardsNumber
    ? !showErrors?.loyaltyNumber && rewardsRegex.test(hertzLoyaltyRewardsNumber)
    : true;

  const renderBackButton = () => (
    <BackButton
      className="hertz-loyalty-rewards-back-button"
      onClick={() => {
        setProgress(HertzLoyaltyStep.Main);
        onGoBack && onGoBack();
      }}
    />
  );

  return (
    <MobilePopoverCard
      open={openHertzLoyaltyFormModal}
      className={clsx("hertz-loyalty-rewards-popup", "mobile", "b2b")}
      onClose={() => {
        setProgress(HertzLoyaltyStep.Main);
        onGoBack && onGoBack();
      }}
      fullScreen
      topLeftButton={!isTravelApp ? renderBackButton() : undefined}
      headerElement={mobileHeaderElement}
    >
      {showHertzLoyalty && (
        <HertzLoyaltyForm
          showErrors={showErrors}
          setShowErrors={setShowErrors}
          isMobile
        />
      )}
      {showFlightNumberForm && <FlightNumberForm isMobile />}
      {(showHertzLoyalty ? hasValidLoyaltyNumber : true) &&
        (showFlightNumberForm ? isFlightInfoValid : true) && (
          <MobileFloatingButton
            className={clsx("mobile-hertz-loyalty-rewards-button", "b2b")}
            wrapperClassName={clsx(
              "mobile-hertz-loyalty-rewards-button-container",
              "b2b"
            )}
            onClick={() => {
              setProgress(HertzLoyaltyStep.Main);
              onContinueClick && onContinueClick();
            }}
          >
            {CONTINUE}
          </MobileFloatingButton>
        )}
    </MobilePopoverCard>
  );
};
